var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadbandinstall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7 21.8074C17.9676 21.8077 18.225 21.9102 18.4196 22.0939C18.6142 22.2776 18.7313 22.5287 18.747 22.7959C18.7627 23.0631 18.6758 23.3261 18.504 23.5314C18.3323 23.7366 18.0886 23.8685 17.8229 23.9001L17.7 23.9074H9.3C9.03238 23.9071 8.77497 23.8047 8.58036 23.6209C8.38576 23.4372 8.26865 23.1861 8.25297 22.919C8.23729 22.6518 8.32421 22.3887 8.49598 22.1835C8.66775 21.9783 8.9114 21.8464 9.17715 21.8148L9.3 21.8074H17.7ZM21.9 10.6074C22.4298 10.6073 22.9401 10.8073 23.3286 11.1676C23.7171 11.5278 23.955 12.0216 23.9948 12.5499L24 12.7074V18.6574C24.0002 19.1872 23.8001 19.6975 23.4398 20.086C23.0796 20.4745 22.5858 20.7124 22.0575 20.7522L21.9 20.7574H5.1C4.57019 20.7576 4.05991 20.5575 3.67142 20.1973C3.28294 19.837 3.04499 19.3432 3.00525 18.8149L3 18.6574V12.7074C2.99983 12.1776 3.19993 11.6673 3.56017 11.2788C3.92042 10.8904 4.41419 10.6524 4.9425 10.6127L5.1 10.6074H21.9ZM21.9 12.7074H5.1V18.6574H21.9V12.7074Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0886 3.64369L22.6011 11.6061",
    stroke: "white",
    strokeWidth: 2.275,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadbandinstall);
export default __webpack_public_path__ + "static/media/broadbandinstall.3ca1853cfcd23e05b09747e9e65931b4.svg";
export { ForwardRef as ReactComponent };